import { render, staticRenderFns } from "./sos.vue?vue&type=template&id=28574b6e&scoped=true&"
import script from "./sos.vue?vue&type=script&lang=js&"
export * from "./sos.vue?vue&type=script&lang=js&"
import style0 from "./sos.vue?vue&type=style&index=0&id=28574b6e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28574b6e",
  null
  
)

export default component.exports